import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgMobile = (props) => /* @__PURE__ */ _jsx("svg", {
	width: 24,
	height: 24,
	viewBox: "1 1 18 18",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		d: "M5.793 1.318 C 5.513 1.386,5.233 1.540,5.005 1.750 C 4.744 1.993,4.575 2.251,4.477 2.560 L 4.398 2.810 4.399 10.005 L 4.401 17.200 4.479 17.445 C 4.669 18.044,5.202 18.540,5.808 18.683 C 5.986 18.725,6.605 18.732,10.000 18.732 C 14.375 18.732,14.189 18.741,14.609 18.529 C 14.871 18.398,15.281 17.989,15.407 17.733 C 15.612 17.320,15.599 17.829,15.600 10.003 C 15.602 2.160,15.615 2.686,15.407 2.267 C 15.281 2.011,14.871 1.602,14.609 1.471 C 14.188 1.259,14.378 1.267,9.983 1.270 C 6.693 1.272,5.949 1.280,5.793 1.318 M14.122 2.619 C 14.334 2.788,14.381 2.923,14.382 3.367 L 14.383 3.750 10.000 3.750 L 5.617 3.750 5.618 3.350 C 5.620 2.924,5.648 2.824,5.805 2.677 C 6.008 2.488,5.737 2.499,10.039 2.508 L 13.994 2.517 14.122 2.619 M14.392 11.008 C 14.383 16.942,14.383 17.018,14.317 17.148 C 14.280 17.220,14.192 17.325,14.122 17.381 L 13.994 17.483 10.000 17.483 L 6.006 17.483 5.878 17.380 C 5.808 17.323,5.720 17.225,5.683 17.163 C 5.617 17.051,5.617 16.982,5.608 11.025 L 5.599 5.000 10.000 5.000 L 14.401 5.000 14.392 11.008 ",
		stroke: "none",
		fillRule: "evenodd",
		fill: "currentColor"
	})
});
export default SvgMobile;
